import React, { Component } from 'react'
import Flickity from 'react-flickity-component'
import * as helpers from "../../helpers/sectionclasses"
import Image from "gatsby-image"
import "flickity/css/flickity.css";

class TeamCarousel extends Component {
  componentDidMount() {
    // let cursor = document.querySelector('.cursor')

    window.addEventListener('load', () => {
      this.flkty.reloadCells();
      this.flkty.resize();
      this.flkty.updateDraggable();
    });

    // this.flkty.on( 'dragMove', function( el ) {
    //   cursor.style.left = `${el.clientX}px`
    //   cursor.style.top = `${el.clientY}px`
    // });


  }


  render() {
    const content = this.props.content
    const sectionClasses = helpers.sectionClasses(content.sectionOptions)
    const flickityOptions = {
      draggable: true,
      wrapAround: false,
      groupCells: 1,
      percentPosition: false,
      imagesLoaded: true,
      prevNextButtons: true,
      pageDots: false
    }

    return (
      <section className={`team-carousel ${sectionClasses}`}>
          <Flickity
            flickityRef={c => this.flkty = c}
            className={'carousel w-full'} // default ''
            elementType={'div'} // default 'div'
            options={flickityOptions} // takes flickity options {}
            disableImagesLoaded={false} // default false
            reloadOnUpdate={true} // default false
            static={false} // default false
          >
          {
            (content.slides) && (
              content.slides.map((slide, index) => {
                return (
                  <div className="w-screen med:px-20 desk:px-0 desk:w-screen/2 desk:mx-20">
                    <div className="relative mb-4 med:mb-10">

                      <div className="aspect-ratio-16/9 relative">
                        {
                          (slide.image?.localFile?.childImageSharp) ?
                            <Image
                              fluid={slide.image.localFile.childImageSharp.fluid}
                              alt={slide.image.localFile.childImageSharp.alt}
                              className="w-full h-full"
                              style={{ position: "absolute" }}
                            />
                          : ''
                        }
                      </div>

                      <div className={`${(index%2 === 0) ? 'med:bottom-10' : 'med:top-10'} px-6 med:px-0 pt-10 med:pt-0 med:absolute med:left-0 transform med:-translate-x-20`}>
                        <p>{slide.title}</p>
                        <p className="text-mobmd med:text-lg">{slide.name}</p>
                      </div>
                    </div>
                    <p className="px-6 med:px-0">{slide.description}</p>
                  </div>
                )
              })
            )
          }

        </Flickity>
      </section>
    )
  }
}

export default TeamCarousel
